/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_R2_TitleInputs */

const en_admin_settings_groups_r2_title = /** @type {(inputs: Admin_Settings_Groups_R2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare R2 / S3`)
};

/**
* | output |
* | --- |
* | "Cloudflare R2 / S3" |
*
* @param {Admin_Settings_Groups_R2_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_r2_title = /** @type {((inputs?: Admin_Settings_Groups_R2_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_R2_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_r2_title(inputs)
});
export { admin_settings_groups_r2_title as "admin.settings.groups.r2.title" }